/**
 * Урожайность хозяйства в кабинете — ОДНО определение на «Обзоре» и вкладке
 * «Сдача» (agroai-6al.53, п. 2 из журнала №546).
 *
 * Прежде у блока «Сдача урожая» на «Обзоре» было число из метрики
 * `harvest.yield_to_date_c_ha` (сдано / вся посевная площадь размещения), а у
 * вкладки «Сдача» — строка хозяйства из `/harvest/deliveries?group=farm`
 * (сдано / площадь контуров, под которыми лежит распределение сдачи). При тех
 * же 50 т они давали 13 и 16 ц/га. Обе подписи на экране говорят одно: «сданное
 * / площадь с отчётом о сборе», — то есть верна вторая, и теперь её читают оба
 * места: одной функцией и одним запросом.
 */

import { request, type QueryParams, type Schemas } from '../../../api/client';
import { useRequest } from '../../../api/useRequest';
import type { SeasonCycle } from './model';

type DeliveryRow = Schemas['HarvestRowOut'];

/** Строка хозяйства → урожайность, ц/га. Нет строки или площади — нет числа. */
export function harvestYieldCHa(row: Pick<DeliveryRow, 'yield_kg_ha'> | null | undefined): number | null {
  const kg = row?.yield_kg_ha;
  return kg == null ? null : kg / 100;
}

/** Сдача хозяйства по циклу: те же параметры, что у вкладки «Сдача». */
export function useFarmDeliveryRow(
  params: QueryParams,
  key: string,
  farmId: number,
  cycle: Pick<SeasonCycle, 'cycle' | 'crop_code' | 'season_label'> | null,
) {
  return useRequest(
    () =>
      cycle
        ? request<Schemas['HarvestDeliveriesOut']>('/harvest/deliveries', {
            ...params,
            crop: cycle.crop_code,
            season: cycle.season_label,
            actor_id: farmId,
            group: 'farm',
          })
        : Promise.resolve(null),
    [cycle?.cycle, farmId, key],
  );
}
